import http from "@/api/request.js";

// export function homeInfo() {
//   //register是封装好的接口名
//   return http.request({
//     url: "/api/index",
//     method: "get",
//   });
// }


// export function aboutuInfo() {
//   //register是封装好的接口名
//   return http.request({
//     url: "/api/aboutus",
//     method: "get",
//   });
// }


// export function linkusInfo() {
//   //register是封装好的接口名
//   return http.request({
//     url: "/api/linkus",
//     method: "get",
//   });
// }

export function productlist(data) {
  return http.request({
    url: "/system/product/list",
    method: "get",
    params: data
  });
}
// 案例
export function caselist(data) {
  return http.request({
    url: "/system/case/list",
    method: "get",
    params: data
  });
}
// 轮播
export function carousellist(data) {
  return http.request({
    url: "/system/carousel/list",
    method: "get",
    params: data
  });
}

//大师级
export function contentlist(data) {
  return http.request({
    url: "/system/content/list",
    method: "get",
    params: data
  });
}
// 资料
export function resourcelist(data) {
  return http.request({
    url: "/system/resource/list",
    method: "get",
    params: data
  });
}

export function contentDetails(data) {
  return http.request({
    url: "/system/content/" + data.id,
    method: "get",
    params: data
  });
}

export function productdetails(data) {
  return http.request({
    url: "system/product/" + data.id,
    method: "get",

  });
}



export function productlisten(data) {
  return http.request({
    url: "/system/producten/list",
    method: "get",
    params: data
  });
}
// 案例
export function caselisten(data) {
  return http.request({
    url: "/system/caseen/list",
    method: "get",
    params: data
  });
}

export function dataproduct_type(data) {
  return http.request({
    url: "/system/dict/data/type/product_type",
    method: "get",
    params: data
  });
}

export function dataproduct_articleno(data) {
  return http.request({
    url: "/system/dict/data/type/product_articleno",
    method: "get",
    params: data
  });
}

export function datafile_type(data) {
  return http.request({
    url: "/system/dict/data/type/file_type",
    method: "get",
    params: data
  });
}

// 轮播
export function carousellisten(data) {
  return http.request({
    url: "/system/carouselen/list",
    method: "get",
    params: data
  });
}

//大师级
export function contentlisten(data) {
  return http.request({
    url: "/system/contenten/list",
    method: "get",
    params: data
  });
}
// 资料
export function resourcelisten(data) {
  return http.request({
    url: "/system/resourceen/list",
    method: "get",
    params: data
  });
}

export function contentDetailsen(data) {
  return http.request({
    url: "/system/contenten/" + data.id,
    method: "get",
    params: data
  });
}

export function productdetailsen(data) {
  return http.request({
    url: "system/producten/" + data.id,
    method: "get",

  });
}

export function hirelist(data){
	return http.request({
	  url: "/system/recruit/list?pageNum="+data.pageNum+"&pageSize="+data.pageSize,
	  method: "get",

	});
}

export function hireenlist(data){
	return http.request({
	  url: "/system/recruiten/list?pageNum="+data.pageNum+"&pageSize="+data.pageSize,
	  method: "get",

	});
}

//应用场景 中文
export function applicationlist(data) {
  return http.request({
    url: "/system/application/list",
    method: "get",
    params: data
  });
}

//应用场景 英文
export function applicationlisten(data) {
  return http.request({
    url: "/system/applicationen/list",
    method: "get",
    params: data
  });
}


//应用场景 分类字典
export function applicationtypelist() {
  return http.request({
    url: "/system/dict/data/type/application_type",
    method: "get"
  });
}




